import AudioPreviewState from './AudioPreviewState';
import IframePreviewState from './IFramePreviewState';
import ImagePreviewState from './ImagePreviewState';
import NativePdfPreviewState from './NativePdfPreviewState';
import PdfJsPreviewState from './PdfJsPreviewState';
import TextPreviewState from './TextPreviewState';
import VideoPreviewState from './VideoPreviewState';
import WacPreviewState from './WacPreviewState';

export enum PreviewPaneMode {
    Blank,
    Loading,
    Error,
    Custom,
    Image,
    Wac,
    Audio,
    Video,
    Text,
    NativePdf,
    PdfJs,
    IFrame,
}

type PreviewPaneViewState =
    | AudioPreviewState
    | IframePreviewState
    | ImagePreviewState
    | NativePdfPreviewState
    | PdfJsPreviewState
    | PreviewPaneBlankViewState
    | PreviewPaneCustomViewState
    | PreviewPaneErrorViewState
    | PreviewPaneLoadingViewState
    | TextPreviewState
    | VideoPreviewState
    | WacPreviewState;

export interface PreviewPaneViewStateBase {
    downloadUrl?: string;
    downloadShouldOpenNewTab?: boolean;
    fileName?: string;
    useHighContrastCommandBar?: boolean;
    id?: any;
}

export default PreviewPaneViewState;

export interface PreviewPaneBlankViewState extends PreviewPaneViewStateBase {
    mode: PreviewPaneMode.Blank;
}

export interface PreviewPaneLoadingViewState extends PreviewPaneViewStateBase {
    mode: PreviewPaneMode.Loading;
    message: string;
}

export interface PreviewPaneErrorViewState extends PreviewPaneViewStateBase {
    mode: PreviewPaneMode.Error;
    errorMessage: string;
}

export interface PreviewPaneCustomViewState extends PreviewPaneViewStateBase {
    mode: PreviewPaneMode.Custom;
}
